"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var WinnersTopList_1 = require("./component/WinnersTopList");
var WinnersTopEditor_1 = require("./component/WinnersTopEditor");
var PWinnersTopList = /** @class */ (function (_super) {
    __extends(PWinnersTopList, _super);
    function PWinnersTopList(props) {
        return _super.call(this, props) || this;
    }
    PWinnersTopList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AB = this.props.brandsData.Subscribe("*", function (id, data) {
            _this.setState({ avail_brands: data.data });
        });
        this.SID_AD = this.props.listTopWinnersDatesAvail.Subscribe("*", function (id, data) {
            _this.setState({
                avail_years: data.years_avail,
                avail_month: data.month_avail
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                brands_list: data.brands_list,
                all_brands: data.all_brands,
                page_size: data.tablePageSize
            });
        });
        this.setState({
            edit_mode: "LIST",
            record: null,
            page_num: 1,
            page_size: this.props.state.getTablePageSize(),
            brands_list: this.props.state.getBrandsList(),
            all_brands: this.props.state.getIsAllBrands(),
            avail_brands: [],
            avail_years: [],
            avail_month: [],
            all_dates: true,
            sel_year: 0,
            sel_month: 0
        }, function () {
            _this.props.brandsData.LoadData();
            _this.props.listTopWinnersDatesAvail.LoadData();
        });
    };
    PWinnersTopList.prototype.componentWillUnmount = function () {
        this.props.brandsData.UnSubscribe(this.SID_AB);
        this.props.listTopWinnersDatesAvail.UnSubscribe(this.SID_AD);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PWinnersTopList.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", record: null });
    };
    PWinnersTopList.prototype.onEditClick = function (val) {
        this.setState({ edit_mode: "EDIT", record: val });
    };
    PWinnersTopList.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", record: null });
    };
    PWinnersTopList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PWinnersTopList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (Action === "checkbox") {
            this.props.state.setAllBrands(allBrands, true);
        }
        if (Action === "add") {
            this.props.state.addBrand(BrandId, true);
        }
        if (Action === "remove") {
            this.props.state.delBrand(BrandId, true);
        }
    };
    PWinnersTopList.prototype.onMonthYearFilterChanged = function (allDates, selYear, selMonth, Action) {
        if (Action === "checkbox") {
            this.setState({ all_dates: allDates });
        }
        if (Action === "year") {
            this.setState({ sel_year: selYear });
        }
        if (Action === "month") {
            this.setState({ sel_month: selMonth });
        }
    };
    PWinnersTopList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(WinnersTopEditor_1.default, { data: this.props.data, state: this.props.state, record: null, onGoBack: this.onGoBackClick.bind(this), brandsAvail: this.state.avail_brands, dataUsrPlayers: this.props.dataUsrPlayers, dataGwsGameProviders: this.props.listGwsGameProviders, dataGwsGameProviderGames: this.props.listGwsGameProviderGames }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(WinnersTopEditor_1.default, { data: this.props.data, state: this.props.state, record: this.state.record, onGoBack: this.onGoBackClick.bind(this), brandsAvail: this.state.avail_brands, dataUsrPlayers: this.props.dataUsrPlayers, dataGwsGameProviders: this.props.listGwsGameProviders, dataGwsGameProviderGames: this.props.listGwsGameProviderGames }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(WinnersTopList_1.default, { data: this.props.data, state: this.props.state, onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this), onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, brandsList: this.state.brands_list, allBrands: this.state.all_brands, availBrands: this.state.avail_brands, onBrandFilterChanged: this.onBrandFilterChanged.bind(this), avail_years: this.state.avail_years, avail_month: this.state.avail_month, all_dates: this.state.all_dates, sel_year: this.state.sel_year, sel_month: this.state.sel_month, onDateFilterChanged: this.onMonthYearFilterChanged.bind(this) }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PWinnersTopList.prototype.render = function () {
        return this.getRenderObject();
    };
    PWinnersTopList.getPageDescription = function (state) {
        return {
            icon: "trophy",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_cms_winners_top_list + "-id",
            itemTitle: "Победители",
            route: routes_1.routes.page_cms_winners_top_list,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PWinnersTopList;
}(React.Component));
exports.default = PWinnersTopList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_winners_top/ui/PWinnersTopList.tsx
// module id = 2335
// module chunks = 0